function validateExcelHeaders({ worksheet, templateHeaders }) {
  return !Object.keys(templateHeaders).some(
    (excelHeader) => templateHeaders[excelHeader] !== worksheet[excelHeader]?.v,
  );
}
export default validateExcelHeaders;
